/**
 * Team colors as the browser presents them.
 *
 * The wire contract is type-only, so the server cannot hand these over at run
 * time. Keying the labels by `TeamColor` is what keeps the two sides honest:
 * adding a color to the union without adding it here is a compile error.
 */

import type { TeamColor } from "../server/protocol.js";

export const TEAM_COLOR_LABELS: Readonly<Record<TeamColor, string>> = {
    blue: "Blue",
    green: "Green",
    orange: "Orange",
    purple: "Purple",
    red: "Red",
    yellow: "Yellow"
};

/**
 * Presentation order for pickers and legends: the additive primaries first,
 * then the rest, so a picker three to a row splits into two even lines.
 *
 * Kept in step with `TEAM_COLORS` on the server, which hands the same order out
 * to teams that stated no preference.
 */
export const TEAM_COLOR_ORDER: readonly TeamColor[] = [
    "red",
    "green",
    "blue",
    "orange",
    "purple",
    "yellow"
];
